<template>
  <b-modal v-model="visible" title="Gia hạn thêm" hide-footer centered @hidden="resetForm">
    <ValidationObserver ref="observer">
      <form @submit.prevent="onSubmit">
        <div>
          <ValidationProvider
            v-if="type === 'extend'"
            name="Số tháng"
            rules="required"
            v-slot="{ errors }"
          >
            <b-form-group>
              <label>Nhập số tháng gia hạn thêm <span style="color: red">*</span></label>
              <input type="text" v-only-number-int-unsigned v-model="form.extensionMonths" />
              <b-form-invalid-feedback :state="errors[0] ? false : null">{{
                errors[0]
              }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider name="Lý do" rules="required" v-slot="{ errors }">
            <b-form-group>
              <label>Nhập lý do <span style="color: red">*</span></label>
              <input type="text" v-model="form.reason" />
              <b-form-invalid-feedback :state="errors[0] ? false : null">{{
                errors[0]
              }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
        </div>

        <!-- Footer -->
        <div class="d-flex justify-content-end mt-4">
          <b-button variant="outline-danger" class="mr-2" @click="closeModal" :disabled="isLoading">
            <b-icon icon="x" scale="2" aria-hidden="true" />
            Thoát
          </b-button>
          <b-button variant="outline-primary" @click="onSubmit" :disabled="isLoading || isType">
            <b-spinner small v-show="isLoading" />
            <b-icon icon="check" scale="2" aria-hidden="true" v-show="!isLoading" />
            Xác nhận
          </b-button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { showMessSuccess } from '@/config/utils'
  export default {
    name: 'ModalExtend',
    data() {
      return {
        visible: false,
        isLoading: false,
        id: '',
        lendingId: '',
        form: {
          reason: '',
          extensionMonths: '',
        },
        type: '',
      }
    },
    computed: {
      isType() {
        return this.type === 'extend'
          ? !this.form.reason || !this.form.extensionMonths
          : !this.form.reason
      },
    },
    methods: {
      closeModal() {
        this.resetForm()
        this.visible = false
      },
      openModal(id, lendingId, type) {
        this.id = id
        this.lendingId = lendingId
        this.type = type
        this.visible = true
      },
      resetForm() {
        this.form = {
          reason: '',
          extensionMonths: '',
        }
      },
      async onSubmit() {
        try {
          this.isLoading = true

          const basePayload = {
            id: this.id,
            lendingId: this.lendingId,
            reason: this.form.reason.trim(),
          }

          const actionMap = {
            extend: {
              service: DeviceService.extendDevice,
              payload: {
                ...basePayload,
                extensionMonths: Number(this.form.extensionMonths),
              },
            },
            recall: {
              service: DeviceService.recallDevice,
              payload: basePayload,
            },
          }
          const { service, payload } = actionMap[this.type]
          const response = await service.bind(DeviceService)(payload)
          if (response.code === 1000) {
            this.$emit('change')
            showMessSuccess(this, 'Gửi yêu cầu thành công')
            this.closeModal()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>
<style lang="scss" scoped></style>
